module.exports = __webpack_public_path__ + "img/notesscrolling-ar.e5a4ac06.png";